import script from "./PurchaseFormItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseFormItem.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseFormItem.vue?vue&type=style&index=0&id=155cf9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155cf9d0"]])

export default __exports__